// extracted by mini-css-extract-plugin
export default {"logoLine":"LogoWrapper_logoLine__tN2WR","logoLineParent":"LogoWrapper_logoLineParent__Ulah-"};